<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">
          <span>
            Test Email
          </span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="testEmail"
                            required
                            label="Email *"
                            :error="!(testEmail && testEmail.length) && isFormDirty" />
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="_close">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="_submit">
          Send Email
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import Vue from "vue";
  import { VueMaskDirective } from "v-mask";

  Vue.directive("mask", VueMaskDirective);

  export default {
    name: "EmailTestDialog",
    components: {},
    props: {
      isVisible: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      isFormDirty: false,
      testEmail: "",
      snackbar: false,
      notification: "Unknown"
    }),

    watch: {
      isVisible(val) {
        if (!val) {
          this.testEmail = "";
        }
      }
    },

    created() { },

    methods: {
      _submit() {
        if (this.testEmail && this.testEmail.length) {
          this.$emit("send-test-message", this.testEmail);
        } else {
          this.notification = "Enter a valid email";
          this.snackbar = true;
        }
      },
      _close() {
        this.$emit("hide");
        this.testEmail = "";
      }
    }
  };
</script>
<style lang="scss" scoped></style>
